import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import { PaymentPage } from "./PaymentPage";
import { PaymentSuccessPage } from "./PaymentSuccessPage";

export function Payment() {
  return (
    <div className="d-flex flex-column flex-root" style={{backgroundColor: 'transparent'}}> 
      <Switch>
        <ContentRoute path="/payment" component={PaymentPage} />
        <ContentRoute path="/payment-success" component={PaymentSuccessPage} />
        <Redirect to="/payment" />
      </Switch>
    </div>
  );
}